<template>
    <div class="main-container">

        <router-view></router-view>
        
        <!-- Navbar section -->
		<HeaderStartup />

		<!-- hero section -->
		<HeroStartup />

        <div class="start-ups-feature startup-about-feature section-space--pt_120 section-space--pb_60 " id="about">
            <div class="container">
                <div class="section-title-wrapper text-center section-space--mb_60">
                    <h2 class="section-title mb-30 wow move-up">I’ve created enticing software for<br>startups and new businesses</h2>
                </div>
                <!-- feature component -->
                <StartUpFeatureTwo />
            </div>
        </div>

        <!-- contact form section -->
        <ContactForm />

        <!-- footer section -->
        <FooterMain FooterStyle="bg_drak-footer" />

    </div>
</template>

<script>
    import HeaderStartup from '../components/HeaderStartup'
    import HeroStartup from '../components/HeroStartup'
    import StartUpFeatureTwo from '../components/StartUpFeatureTwo'
    import ContactForm from '../components/ContactForm'

    import FooterMain from '../components/FooterMain'

    export default {
        name: 'app',
        components: {
            HeaderStartup,
            HeroStartup,
            StartUpFeatureTwo,
            ContactForm,
            FooterMain
        }
    }
</script>

